

























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Contract as IContract } from "@/api/models/contract";
import { Bill as IBill } from "@/api/models/bill";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { BillEdit as IBillEdit } from "@/api/models/bill-edit";
import { isRoot } from "@/plugins/roles";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import LearningResourceTable from "@/components/learning-resource/LearningResourceTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { LearningResourceInfo as ILearningResourceInfo } from "@/api/models/learning-resource-info";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { nextSequence } from "@/utils/generate-helper";

/**
 * This form in contract page
 */
@Component({
  components: {
    DocumentNumberInput,
    CSingleSelect,
    Modal,
    CustomButton,
    CustomDatepicker,
    LearningResourceTable
  }
})
export default class BillForm extends Vue {
  @Prop() contract!: IContract;
  @Prop() bill?: IBill;
  checkedResources: Array<ILearningResourceInfo> | undefined = [];
  number!: string;
  learningResources: Array<ILearningResourceInfo> | undefined = this.bill
    ? this.bill.learningResources
    : this.contract.learningResources;
  responsibleId: string | undefined;
  responsibleList!: IEmployeesList2;
  formedAt?: Date | undefined;
  isSavingBill: boolean = false;
  changed: boolean = false;
  price!: number;

  data() {
    return {
      number: undefined,
      price: undefined,
      responsibleId: undefined,
      responsibleList: undefined,
      formedAt: undefined
    };
  }

  returnThisDay() {
    this.formedAt = new Date();
  }

  saveBill() {
    if (!this.bill) {
      if (this.number) {
        this.isSavingBill = true;
        let params: IBillEdit = {
          contractId: this.contract.id,
          number: this.number,
          price: this.$converter.setPrice(this.price),
          learningResources: this.checkedResources,
          responsibleId: this.responsibleId!,
          formedAt: this.formedAt ? this.formedAt : undefined
        };
        if (this.price > this.$converter.getPrice(this.contract.amount)) {
          this.$bvToast.toast(
            `${this.$tc(
              this.$translate
                .YouCannotCreateInvoiceAmountGreaterThanContractAmount
            )}`,
            {
              variant: "danger",
              title: `${this.$tc(this.$translate.Error)}`
            }
          );
          this.isSavingBill = false;
        } else {
          api.BillApi.create(params)
            .then(async () => {
              await nextSequence();
              this.$emit("updateBill");
            })
            .finally(() => {
              this.isSavingBill = true;
            })
            .catch(
              (
                error: AxiosError<IErrorResponse | IValidationErrorResponse>
              ) => {
                if (error.response?.data.message) {
                  this.$bvToast.toast(error.response.data.message, {
                    variant: "danger",
                    title: `${this.$tc(this.$translate.Error)}`
                  });
                }
              }
            );
        }
      }
    } else {
      if (this.number) {
        let params: IBillEdit = {
          contractId: this.contract.id,
          fileIds: [],
          number: this.number,
          responsibleId: this.responsibleId!,
          learningResources: this.checkedResources,
          price: this.$converter.setPrice(this.price),
          formedAt: this.formedAt ? this.formedAt : undefined
        };
        api.BillApi.edit(this.bill.id, params)
          .then(async (res: { data: IBill }) => {
            await nextSequence();
            await this.$router.push({
              name: "bill",
              params: { billId: res.data.id }
            });
          })
          .finally(() => {
            this.isSavingBill = false;
          })
          .catch(
            (error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
              if (error.response?.data.message) {
                this.$bvToast.toast(error.response.data.message, {
                  variant: "danger",
                  title: `${this.$tc(this.$translate.Error)}`
                });
              }
            }
          );
      }
    }
  }

  deleteBill() {
    if (this.bill) {
      api.BillApi._delete(this.bill.id)
        .then(() => {
          this.$router.push({ name: "bills" });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get currentEmployee() {
    return this.$store.getters.userIsEmployee;
  }

  getResponsibleList() {
    let params: EmployeeListParams = {
      id: this.contract.companyId,
      roles: ["document_manager"],
      limit: 900
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.responsibleList = res.data;
      if (this.responsibleList.employees.length && !this.bill) {
        if (this.root || this.companyOwner) {
          this.responsibleId = this.responsibleList.employees[0].id;
        } else {
          this.responsibleId = this.currentEmployee.id;
        }
      }
    });
  }

  setValue() {
    if (this.bill) {
      this.checkedResources = this.bill.learningResources;
      this.price = this.bill.price;
      this.number = this.bill.number;
      this.formedAt = this.bill.formedAt;
      this.responsibleId = this.bill.responsibleId;
    }
  }

  @Watch("checkedResources")
  checkCheckedResource() {
    if (!!this.bill && !this.changed) {
      this.price = this.$converter.getPrice(this.bill.price);
      this.changed = true;
      return;
    }
    if (this.checkedResources && this.checkedResources.length > 0) {
      let price: number;
      price = this.checkedResources
        .map(el => el.amount)
        .reduce((acc, item) => {
          return acc + item;
        });
      this.price = this.$converter.getPrice(price);
      this.changed = true;
    } else {
      this.price = 0;
      this.changed = true;
    }
  }

  mounted() {
    this.getResponsibleList();
    this.setValue();
  }
}
